import React from 'react';
import { css, toList } from '../../lib/render.jsx';
import { Herstel, Kader, Kruis, Potlood } from '../Iconen.jsx';

export default function AvatarEditor({ v }) {
  if (!v.showAvatarEditor) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" onClick={v.cancelAvatarEditor} style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "99", "padding": "16px" }}>
        <div className="gp-venster" onClick={v.stopProp} style={{ "width": "min(400px,100%)", "maxHeight": "calc(100dvh - 32px)", "overflowY": "auto", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "14px" }}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px", "flex": "0 0 auto" }}>
            <div style={{ "fontSize": "19px", "fontWeight": "700", "flex": "1 1 auto" }}>
              Jouw avatar
            </div>
            <button onClick={v.cancelAvatarEditor} title="Sluiten, zonder je wijzigingen" style={css(v.sluitStyle)}>
              <Kruis maat={20} />
            </button>
          </div>
          <div ref={v.avGridRef} onMouseUp={v.avStopPaint} onMouseLeave={v.avStopPaint} onContextMenu={v.onAvatarContext} style={{ "position": "relative", "display": "grid", "gridTemplateColumns": "repeat(8,1fr)", "gridTemplateRows": "repeat(8,1fr)", "boxSizing": "border-box", "width": "100%", "aspectRatio": "1/1", "flex": "0 0 auto", "border": "3px solid var(--ink)", "borderRadius": "12px", "overflow": "hidden", "boxShadow": "3px 3px 0 var(--ink)", "background": "#fff" }}>
            {toList(v.avatarCells).map((c, $index) => (
              <React.Fragment key={$index}>
                <div onMouseDown={c?.onDown} onMouseEnter={c?.onEnter} style={css(c?.style)} />
              </React.Fragment>
            ))}
            {v.avSelVak ? (
              <svg style={css(v.avSelSvgStyle)} viewBox="0 0 8 8" preserveAspectRatio="none" aria-hidden="true">
                <rect
                  x={v.avSelVak.x} y={v.avSelVak.y} width={v.avSelVak.w} height={v.avSelVak.h}
                  fill="rgba(124,92,255,.18)" stroke="var(--paars)" strokeWidth="3"
                  vectorEffect="non-scaling-stroke" strokeDasharray="6 6" strokeLinecap="square"
                  style={css(v.avSelVakStyle)}
                />
              </svg>
            ) : null}
          </div>
          {/* Eén raster van zes, twee volle rijen van zes: boven zes kleuren, onder de
              laatste twee kleuren en het gereedschap. Twaalf dingen in een raster van
              zes gaat precies op, dus elk vakje is even groot en er zit nergens een gat.

              Alles is een echte knop, ook de kleuren: het zijn dingen die je aanklikt,
              en een div die je aanklikt bestaat voor een schermlezer en voor je
              toetsenbord niet. Alle twaalf hebben hetzelfde reliëf, want ze doen
              hetzelfde soort ding. */}
          <div style={{ "display": "grid", "gridTemplateColumns": "repeat(6,1fr)", "gap": "8px", "flex": "0 0 auto" }}>
            {toList(v.avatarPalette).map((p, $index) => (
              <React.Fragment key={$index}>
                <button onClick={p?.onClick} className="gp-swatch" title={p?.titel} aria-label={p?.titel} aria-pressed={p?.gekozen} style={css(p?.style)} />
              </React.Fragment>
            ))}
            <button onClick={v.avPickPen} className="gp-btn" title="Tekenen" style={css(v.avPenStyle)}>
              <Potlood maat={16} />
            </button>
            <button onClick={v.avPickSel} className="gp-btn" title="Een vlak aanwijzen" style={css(v.avSelStyle)}>
              <Kader maat={16} />
            </button>
            <button onClick={v.avPickEraser} className="gp-btn" title="Gum" aria-pressed={v.avGumGekozen} style={css(v.avEraserStyle)}>
              {' '}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.3" strokeLinecap="round" strokeLinejoin="round">
                <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21" />
                <path d="M22 21H7" />
              </svg>
              {' '}
            </button>
            <button onClick={v.avClear} className="gp-btn" title="Opnieuw beginnen" aria-label="Opnieuw beginnen" style={css(v.avOpnieuwStyle)}>
              <Herstel maat={16} />
            </button>
          </div>
          <button onClick={v.closeAvatarEditor} className="gp-btn pink" style={{ "flex": "0 0 auto", "justifyContent": "center" }}>
            Klaar
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
